module.exports = __webpack_public_path__ + "img/agro_catraca_1000ml.c7b1ff19.png";